import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ff7b41a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_select, {
        items: _ctx.items,
        class: "sort",
        "model-value": _ctx.sortType,
        "onUpdate:modelValue": _ctx.changeSort,
        label: "Sort by",
        variant: "underlined"
      }, null, 8, ["items", "model-value", "onUpdate:modelValue"]),
      _createVNode(_component_v_text_field, {
        "model-value": _ctx.search,
        "onUpdate:modelValue": _ctx.changeSearch,
        counter: 10,
        class: "search",
        label: "Search",
        variant: "underlined"
      }, null, 8, ["model-value", "onUpdate:modelValue"])
    ])
  ]))
}